import React, { Component } from "react";
import { connect } from "react-redux";
import ACTIONS from "../../common/action_constant";
import { debounce } from "../../utils/index.js";
import viewIcon from "../../assets/images/view.svg";
import searchIcon from "../../assets/images/Search.svg";
import CoromandelVendorModal from "./CoromandelVendorModal";
import Button from "../button-classic/button-classic";
import "./company_category.less";
import "./coromandel_vendors.less";

const AVATAR_COLORS = ['#528aea', '#e67e22', '#27ae60', '#8e44ad', '#c0392b', '#16a085', '#2980b9', '#d35400'];

function getInitials(name = '') {
  return name.trim().split(/\s+/).slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?';
}

function getAvatarColor(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

class CoromandelVendors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sapVendorProviders: [],
      selectedVendor: null,
      search: '',
      isSearching: false,
      offset: 0,
    };
    this.debouncedSearch = debounce((searchVal) => this.fetchVendors(searchVal, 0), 400);
  }

  componentDidMount() {
    this.fetchVendors('', 0);
  }

  fetchVendors = (searchVal, offset) => {
    const queryParams = { companyId: this.props.company_id, limit: 10, offset };
    if (searchVal) queryParams.search = searchVal;

    this.props.dispatch({
      type: ACTIONS.HOME.FETCH_SAP_VENDOR_PROVIDERS,
      queryParams,
      onSuccess: (data) => {
        this.setState({ sapVendorProviders: data.list || [], offset, isSearching: false });
      },
    });
  };

  onSearchChange = (e) => {
    const search = e.target.value;
    this.setState({ search, isSearching: true });
    this.debouncedSearch(search);
  };

  clearSearch = () => {
    this.setState({ search: '', isSearching: false });
    this.fetchVendors('', 0);
  };

  openModal = (vendor) => this.setState({ selectedVendor: vendor });
  closeModal = () => this.setState({ selectedVendor: null });

  renderStatusBadge = (isActive) => (
    <span className={`cv-badge ${isActive ? 'cv-badge--active' : 'cv-badge--inactive'}`}>
      <span className="cv-badge-dot" />{isActive ? 'Active' : 'Inactive'}
    </span>
  );

  render() {
    const { sapVendorProviders, search, selectedVendor, isSearching, offset } = this.state;
    console.log('sapVendorProviders:', sapVendorProviders)

    return (
      <div className="company-category-wrap cv-wrap">

        <div className="cv-page-header">
          <div className="cv-header-left">
            <div className="cv-title">Vendors</div>
          </div>

          <div className={`cv-search-box ${search ? 'cv-search-box--active' : ''}`}>
            <img src={searchIcon} className="cv-search-icon" alt="search" />
            <input
              className="cv-search-input"
              placeholder="Search vendors..."
              value={search}
              onChange={this.onSearchChange}
            />
            {isSearching && <span className="cv-search-spinner" />}
            {search && !isSearching && (
              <span className="cv-search-clear" onClick={this.clearSearch}>✕</span>
            )}
          </div>
        </div>

        <div className="cv-table-wrap">
          <div className="cv-table-header cv-table-row">
            <div className="cv-col cv-col--num">Sl No.</div>
            <div className="cv-col cv-col--name">Company</div>
            <div className="cv-col">PAN No</div>
            <div className="cv-col cv-col--phone">Contact</div>
            <div className="cv-col cv-col--email">Email</div>
            <div className="cv-col">SAP Vendor Code</div>
            <div className="cv-col cv-col--action">Action</div>
          </div>

          <div className="cv-table-body">
            {sapVendorProviders.length === 0 ? (
              <div className="cv-empty-state">
                <div className="cv-empty-icon">🔍</div>
                <div>{search ? `No results for "${search}"` : 'No vendors found'}</div>
              </div>
            ) : (
              sapVendorProviders.map((vendor, index) => {
                const initials = getInitials(vendor.company_name);
                const avatarColor = getAvatarColor(vendor.company_name);
                const sapCodes = (vendor.sap_vendor_details || []).map(s => s.sap_vendor_code).filter(Boolean);
                return (
                  <div className="cv-table-row cv-data-row" key={index}>
                    <div className="cv-col cv-col--num cv-row-num">{offset + index + 1}</div>
                    <div className="cv-col cv-col--name">
                      <div className="cv-avatar" style={{ background: avatarColor }}>{initials}</div>
                      <span className="cv-company-name">{vendor.company_name || '—'}</span>
                    </div>
                    <div className="cv-col cv-pan">{vendor.pan_no || '—'}</div>
                    <div className="cv-col cv-col--phone">{vendor.contact || vendor.user_contact || '—'}</div>
                    <div className="cv-col cv-col--email cv-email-cell">{vendor.email || vendor.user_email || '—'}</div>
                    <div className="cv-col cv-sap-cell">
                      {sapCodes.length > 0 ? (
                        <>
                          {sapCodes.slice(0, 2).map((code, i) => <div key={i}>{code}</div>)}
                          {sapCodes.length > 2 && <div className="cv-sap-more">+{sapCodes.length - 2} more</div>}
                        </>
                      ) : '—'}
                    </div>
                    <div className="cv-col cv-col--action">
                      <button className="cv-view-btn" onClick={() => this.openModal(vendor)}>
                        <img src={viewIcon} alt="view" className="cv-view-icon" />
                        View
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={() => this.fetchVendors(search, offset + 10)} />
          </div>
          <div className="pre">
            <Button value="Previous" disabled={offset === 0} click={() => this.fetchVendors(search, offset - 10)} />
          </div>
        </div>

        {selectedVendor && (
          <CoromandelVendorModal
            vendor={selectedVendor}
            onClose={this.closeModal}
            seekerCompanyId={this.props.company_id}
            dispatch={this.props.dispatch}
          />
        )}
      </div>
    );
  }
}

export default connect()(CoromandelVendors);
